import { useQuery } from "react-query";
import { getCSV } from "../../data";

export const useExportCsv = (url, settings) => {
    return useQuery({
        queryKey: ["export-csv"],
        queryFn: () => getCSV(url, settings),
        enabled: false,
    });
};
